
  <button appTooltip="Measure" class="esk-tool" [ngClass]="{'esk-tool--active' : active()===true}" (click)="active.set(!active())"><i class="fa fa-ruler-horizontal"></i></button>
  @if(active() == true)
  {
    <app-toolbar>
      <measure-settings [formControl]="drawType"></measure-settings>
      <button appTooltip="Clear Measurements" class="esk-tool" (click)="clear()"><i class="fa fa-trash"></i></button>
    </app-toolbar>
  }
